import { BUSINESS, TEL_HREF, WA_HREF, MAIL_HREF } from "../../lib/business";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F0F10] text-white relative overflow-hidden"
    >
      <div
        className="absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, #D4AF37 50%, transparent 100%)",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="overline" style={{ color: "#D4AF37" }}>
              Purity is Priority
            </div>
            <div className="font-serif-display text-4xl md:text-6xl mt-4 leading-[1.05] tracking-tight">
              WHITE BULL
              <br />
              GLOBAL
            </div>
            <p className="text-white/60 mt-6 max-w-md leading-relaxed">
              Nutraceutical & supplement manufacturer based in Sonipat, Haryana.
              FSSAI, GMP and AYUSH certified.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="overline" style={{ color: "#D4AF37" }}>
              Contact
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-call"
                  href={TEL_HREF}
                  className="inline-flex items-start gap-3 text-white/80 hover:text-[#D4AF37] transition-colors"
                >
                  <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  {BUSINESS.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-whatsapp"
                  href={WA_HREF}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-start gap-3 text-white/80 hover:text-[#D4AF37] transition-colors"
                >
                  <MessageCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  {BUSINESS.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href={MAIL_HREF}
                  className="inline-flex items-start gap-3 text-white/80 hover:text-[#D4AF37] transition-colors break-all"
                >
                  <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  {BUSINESS.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="overline" style={{ color: "#D4AF37" }}>
              Facility
            </div>
            <div className="mt-5 flex items-start gap-3 text-sm text-white/80 leading-relaxed">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-white/80" />
              <span>{BUSINESS.addressShort}</span>
            </div>
            <div className="mt-5 text-xs text-white/50 tracking-wide uppercase">
              {BUSINESS.hoursShort}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} White Bull Global Pvt Ltd. All rights
            reserved.
          </div>
          <div className="tracking-[0.24em] uppercase">
            FSSAI · GMP · AYUSH Certified
          </div>
        </div>
      </div>
    </footer>
  );
};
